import { ServiceClient } from 'src/utils'
import { SerasaViewRow } from './serasa.types'

const serviceClient = ServiceClient.singleton()

export class SerasaService {
    static #INSTANCE = new SerasaService()
    static readonly singleton = () => SerasaService.#INSTANCE

    async fetchSerasaViewInfo(cpfCnpj: string, type?: string): Promise<SerasaViewRow> {
        return serviceClient.authGet<SerasaViewRow>(
            `/api/serasaview/query/v1/${cpfCnpj}${type !== 'motor' ? `?type=${type}` : ''}`
        )
    }
}

export default SerasaService.singleton()
